import type { ReactNode } from 'react';
import { Box, Flex, Heading, Text, VStack } from '@chakra-ui/react';
import { LogoMark } from '../brand/Logo';

// The signed-out screens (sign in, joining a family, the system root):
// the Home talk mark, a big title, and one plain column (Living Room).
export function WelcomeShell({
  title,
  handle,
  subtitle,
  children,
  footer,
}: {
  title: string;
  /** A family's handle under its name on the join pages (D217). */
  handle?: string | null;
  subtitle?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <Flex
      minH="var(--app-height, 100vh)"
      bg="canvas"
      direction="column"
      align="center"
      px={4}
      pt="max(env(safe-area-inset-top), 48px)"
      pb="max(env(safe-area-inset-bottom), 24px)"
    >
      <VStack
        flex="1"
        w="full"
        maxW="420px"
        spacing={8}
        justify="center"
        align="stretch"
      >
        <VStack spacing={4} textAlign="center">
          <LogoMark size={72} />
          <VStack spacing={2}>
            <Heading
              as="h1"
              fontSize="36px"
              lineHeight={1.05}
              letterSpacing="-0.02em"
            >
              {title}
            </Heading>
            {handle && (
              <Text fontSize="17px" fontWeight={600} color="muted">
                @{handle}
              </Text>
            )}
            {subtitle && (
              <Text fontSize="17px" lineHeight="25px" color="ink.body">
                {subtitle}
              </Text>
            )}
          </VStack>
        </VStack>
        <Box>{children}</Box>
      </VStack>
      {footer && (
        <Text
          fontSize="14px"
          color="muted"
          textAlign="center"
          maxW="420px"
          pt={6}
        >
          {footer}
        </Text>
      )}
    </Flex>
  );
}
